(function () {
  if (window.KPodOfferCountdown) {
    window.KPodOfferCountdown.init(document);
    return;
  }

  var selector = '[data-kpod-offer-countdown]';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function setValue(element, part, value) {
    var output = element.querySelector('[data-countdown-' + part + ']');
    if (output) output.textContent = pad(value);
  }

  function expire(element) {
    var targetId = element.dataset.expiryTarget;
    var target = targetId ? document.getElementById(targetId) : null;

    element.dataset.complete = 'true';
    if (target) target.hidden = true;
  }

  function update(element) {
    if (!element.isConnected) return false;

    var endTime = Date.parse(element.dataset.end);
    if (Number.isNaN(endTime)) {
      element.dataset.invalid = 'true';
      return false;
    }

    var remaining = Math.max(0, endTime - Date.now());
    var days = Math.floor(remaining / 86400000);
    var hours = Math.floor((remaining % 86400000) / 3600000);
    var minutes = Math.floor((remaining % 3600000) / 60000);
    var seconds = Math.floor((remaining % 60000) / 1000);

    setValue(element, 'days', days);
    setValue(element, 'hours', hours);
    setValue(element, 'minutes', minutes);
    setValue(element, 'seconds', seconds);
    element.setAttribute(
      'aria-label',
      'Summer offer ends in ' +
        days +
        ' days, ' +
        hours +
        ' hours, ' +
        minutes +
        ' minutes and ' +
        seconds +
        ' seconds'
    );

    if (remaining === 0) {
      expire(element);
      return false;
    }

    return true;
  }

  function start(element) {
    if (element.dataset.countdownReady === 'true') return;
    element.dataset.countdownReady = 'true';

    if (!update(element)) return;

    var interval = window.setInterval(function () {
      if (!update(element)) window.clearInterval(interval);
    }, 1000);
  }

  function init(root) {
    if (root.matches && root.matches(selector)) start(root);
    root.querySelectorAll(selector).forEach(start);
  }

  window.KPodOfferCountdown = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
